import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createAiProvider } from '@/lib/api/generated/api';

import { toAiProviderError } from '../errors';
import { aiProviderKeys } from '../queryKeys';
import type { AiProvider, AiProviderWriteInput } from '../types';

/** Create a new AI Provider for the organization. */
export function useCreateAiProvider() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: AiProviderWriteInput): Promise<AiProvider> => {
      const response = await createAiProvider({
        name: body.name,
        provider_type: body.provider_type,
        base_url: body.base_url,
        token: body.token ?? '',
      });
      if (response.status === 201) return response.data;
      throw toAiProviderError(response.status, response.data);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: aiProviderKeys.all() });
    },
  });
}
